import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Lightweight tooltip using CSS hover. No extra dependencies needed.
 * Displays a small popover on hover with an explanation text.
 */
function Tooltip({ children, content, side = 'top', className }) {
    if (!content) return children;

    const positionClasses = {
        top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    };

    return (
        <div className="relative inline-flex group">
            {children}
            <div className={cn(
                "absolute z-50 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-200",
                "px-2.5 py-1.5 rounded-lg text-xs font-medium max-w-[220px] whitespace-normal",
                "bg-zinc-900 dark:bg-zinc-100 text-zinc-100 dark:text-zinc-900 shadow-xl",
                "border border-zinc-700 dark:border-zinc-300",
                positionClasses[side] || positionClasses.top,
                className
            )}>
                {content}
                {/* Arrow */}
                <div className={cn(
                    "absolute w-2 h-2 rotate-45 bg-zinc-900 dark:bg-zinc-100 border-zinc-700 dark:border-zinc-300",
                    side === 'top' && 'top-full left-1/2 -translate-x-1/2 -mt-1 border-b border-r',
                    side === 'bottom' && 'bottom-full left-1/2 -translate-x-1/2 -mb-1 border-t border-l',
                    side === 'left' && 'left-full top-1/2 -translate-y-1/2 -ml-1 border-r border-b',
                    side === 'right' && 'right-full top-1/2 -translate-y-1/2 -mr-1 border-l border-t',
                )} />
            </div>
        </div>
    );
}

function TooltipProvider({ children }) {
    return <>{children}</>;
}

export { Tooltip, TooltipProvider };
